import React, { Component } from 'react';
import moment from 'moment';
import { CURRENCY, FORMAT_NUMBER } from '../libs/utils/Const';
import ApiClient from '../libs/apiClient';
import { event } from 'jquery';
import { Modules, decodeText } from '../libs/utils/Const';
const apiClient = ApiClient.getInstance();

const headersBody = [
    { title: "N° de orden", value: true },
    { title: "N° de serie", value: true },
    { title: "N° de linea", value: true },
    { title: "Tipo", value: true },
    { title: "N° de Articulo", value: true },
    { title: "Desc. del Articulo", value: true },
    { title: "Cantidad", value: true },
    { title: "Costo del articulo", value: false },
    { title: "Planif", value: true },
    { title: "Almacén", value: true },
    { title: "Nom. Unidad de medida", value: true },
    { title: "CANAL", value: Modules.CostCenter },
    { title: "SEDES", value: Modules.CostCenter },
    { title: "SUCURSAL", value: Modules.CostCenter },
    { title: "NEGOCIO", value: Modules.CostCenter },
    { title: "CECO", value: Modules.CostCenter },
];

class ContentGoodsIssue extends Component {

    // ChangeProp
    ChangePropInModel = (prop, value) => {
        const { newOrderModel, RefreshModel } = this.props
        newOrderModel[prop] = value;
        RefreshModel(newOrderModel);
    }

    openSeries = () => {
        const { openSeries } = this.props;
        openSeries()
    }

    changeLineField = async (key, index, value, maxLength = null, isNumber = false) => {
        const { newOrderModel, RefreshModel } = this.props;
        maxLength = isNumber ? 19 : maxLength;
        let newValue = value ?? '';

        if (isNumber) {
            newValue = newValue?.replace(/[^0-9.]/g, '');
            const parts = newValue?.split('.');
            if (parts?.length > 2) {
                newValue = parts[0] + '.' + parts?.slice(1)?.join('');
            }
        }

        if (maxLength) {
            newValue = newValue?.slice(0, maxLength);
        }

        newOrderModel.DocumentLines[index][key] = newValue;
        await RefreshModel(newOrderModel);
    };

    changeBlurLineField = async (key, index, value, toFixedValue = null) => {
        const { newOrderModel, RefreshModel } = this.props;
        if (toFixedValue || toFixedValue === 0) {
            value = !value || value === '.' ? 0 : value;
            newOrderModel.DocumentLines[index][key] = Number(value || 0)?.toFixed(toFixedValue);
            await RefreshModel(newOrderModel);
        }
    }

    renderHeader = () => {
        const { action, newOrderModel, editMode } = this.props;
        return (
            <div className="row">
                <div className="col-12 col-md-6">
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold">Número</span>
                        </div>
                        <input type="text" className="form-control"
                            value={newOrderModel ? newOrderModel.DocNum : ''}
                            disabled={true}
                        />
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Serie</span>
                        </div>
                        <input type="text" className="form-control"
                            id="txtSerieGI"
                            value={newOrderModel.SerieName ? newOrderModel.SerieName : ''}
                            disabled={true}
                        />
                        {action === 1 && (
                            <button
                                disabled={action === 2}
                                type="button"
                                style={{ backgroundColor: 'transparent', color: '#EABF28' }}
                                className="input-group-text"
                                onClick={() => this.openSeries()}>
                                <i className="fa fa-list" aria-hidden="true" />
                            </button>
                        )}
                    </div>
                </div>

                {/*Segunda columna*/}
                <div className="col-12 col-md-6">
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">Fecha de contabilización</span>
                                <span className="d-inline d-xl-none">F. Conta</span>
                            </span>
                        </div>
                        <input
                            type="date"
                            className="form-control"
                            id="txtDocDateIG"
                            autoComplete='off'
                            value={newOrderModel && newOrderModel.DocDate ? moment(newOrderModel.DocDate).format("YYYY-MM-DD") : ''}
                            onChange={(event) => this.ChangePropInModel("DocDate", event.target.value)}
                            disabled={(action === 2 && !editMode) ? true : false}
                        />
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Referencia 2</span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtRef2GI"
                            onChange={(event) => this.ChangePropInModel("Reference2", event.target.value)}
                            value={newOrderModel ? newOrderModel.Reference2 : ''}
                            disabled={(action === 2 && !editMode) ? true : false}
                        />
                    </div>
                </div>
            </div>
        );
    }

    renderBody = () => {
        const { action, newOrderModel, editMode, openCentroCoste } = this.props;
        return (
            <div style={{ marginBottom: 30 }}>
                <nav>
                    <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <a
                            className={"nav-item nav-link font-weight-bold text-secondary"}
                            id="nav-profile-tab-Contenido-D"
                            data-toggle="tab"
                            href="#dataContenidoDocument"
                            role="tab"
                            aria-controls="dataContenidoDocument"
                            aria-selected="true">
                            Contenido
                        </a>
                    </div>
                </nav>

                <div className="tab-content" style={{ paddingTop: 5, textAlign: 'left' }}>
                    {/* CONTENIDO */}
                    <div
                        className="w-100 table-scroll tab-pane fade"
                        id="dataContenidoDocument"
                        role="tabpanel"
                        aria-labelledby="nav-home-tab-Contenido"
                        style={{ maxHeight: 2000, maxWidth: 3000, paddingTop: 5 }}
                    >
                        <table
                            id="dataTableDocuments"
                            className="display"
                            style={{ width: '100%', marginBottom: 40, marginRight: -30000 }}>
                            <thead className="table-header-yellow">
                                <tr style={{ textAlign: "center" }}>
                                    {/* <td className="sticky-column sticky-header" style={{ width: 40, background: "#d2ab24" }}>
                                        #
                                    </td> */}
                                    {headersBody.map((header, index) => {
                                        if (header.value) {
                                            return (
                                                <td key={index} className="sticky-header" style={{ ...header.style, background: "#d2ab24" }}>
                                                    {header.title}
                                                </td>
                                            );
                                        }
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {newOrderModel.hasOwnProperty("DocumentLines") && newOrderModel.DocumentLines.map((line, index) => {

                                    return (
                                        <tr>
                                            {/* <td className="sticky-column" style={{ backgroundColor: '#FFF' }}>
                                                {Number(line.LineNum) + 1}
                                            </td> */}
                                            <td
                                                className="overflow-visible"
                                                style={{ textAlign: 'center', maxWidth: 200 }}>
                                                {line?.BaseRef ?? ""}
                                            </td>
                                            <td
                                                className="overflow-visible"
                                                style={{ textAlign: 'center', maxWidth: 200 }}>
                                                {line?.SeriesName ?? line?.Series ?? ''}

                                            </td>
                                            <td
                                                className="overflow-visible"
                                                style={{ textAlign: 'center', maxWidth: 200 }}>
                                                {Number(line?.LineNum) + 1}
                                            </td>
                                            <td
                                                className="overflow-visible"
                                                style={{ textAlign: 'center', maxWidth: 200 }}>
                                                <select
                                                    className="form-control"
                                                    id={'selectTypeLine' + line.LineNum}
                                                    // disabled={(Number(action) === 2 && !editMode) ? true : false}
                                                    disabled={true}
                                                    value={line?.ItemType ?? ''}
                                                    style={{ width: '12vh' }}
                                                // onChange={(event) => this.changeUserFieldsItemsDocument(event, field.IdValue, index)}
                                                >

                                                    <option value={4}>Articulo</option>
                                                    <option value={290}>Recurso</option>
                                                </select>
                                            </td>
                                            <td
                                                className="overflow-visible"
                                                style={{ textAlign: 'center', maxWidth: 200 }}>
                                                {line?.ItemCode ?? ""}
                                            </td>
                                            <td
                                                className="overflow-visible"
                                                style={{ textAlign: 'center', maxWidth: 200 }}>
                                                {line?.ItemDescription ?? ""}
                                            </td>
                                            {/* Cantidad */}
                                            <td
                                                className="overflow-visible"
                                                style={{ textAlign: 'center', maxWidth: 200 }}>
                                                {/* {line?.Quantity ?? ""} */}
                                                <input
                                                    style={{ minWidth: '100px' }}
                                                    disabled={(action !== 1)}
                                                    value={line?.Quantity}
                                                    id={`Quantity-${index}`}
                                                    className="form-control"
                                                    type="text"
                                                    onFocus={(event) => event.target.select()}
                                                    onChange={(e) => action === 1 && this.changeLineField('Quantity', index, e.target.value, null, true)}
                                                    onBlur={(e) => action === 1 && this.changeBlurLineField('Quantity', index, e.target.value, 4)}
                                                />
                                            </td>
                                            {/* <td
                                                className="overflow-visible"
                                                style={{ textAlign: 'center', maxWidth: 200 }}>
                                                {(CURRENCY + ' ' + FORMAT_NUMBER.new(line?.Price)) ?? ""}
                                            </td> */}
                                            <td
                                                className="overflow-visible"
                                                style={{ textAlign: 'center', maxWidth: 200 }}>
                                                {line?.PlannedQty ?? ""}
                                            </td>
                                            {/* Almacén */}
                                            <td
                                                className="overflow-visible"
                                                style={{ textAlign: 'center', minWidth: 200, whiteSpace: 'nowrap' }}>
                                                {`${line?.WhsCode ?? ''}${line?.WhsName ? `- ${decodeText(line?.WhsName)}` : ''}`}
                                            </td>
                                            {/* Unidad de medida */}
                                            <td
                                                className="overflow-visible"
                                                style={{ textAlign: 'center', maxWidth: 200 }}>
                                                {line?.unitMsr ?? ""}
                                            </td>
                                            {Modules.CostCenter && <>
                                                <td style={{ minWidth: 150 }}>
                                                    <div className="input-group">
                                                        <input
                                                            className="form-control"
                                                            disabled
                                                            readOnly
                                                            value={line?.OcrCode || ""} />

                                                        {((action === 1 || (action === 2 && editMode)) && !line?.Dimension1) && (
                                                            <div className="input-group-append" >
                                                                <button
                                                                    type="button"
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        color: '#EABF28',
                                                                        paddingTop: 2,
                                                                        paddingBottom: 2,
                                                                        border: "1px solid #ced4da"
                                                                    }}
                                                                    className="btn btn-outline-secondary"
                                                                    onClick={() => openCentroCoste(index, 1)}>
                                                                    <i className="fa fa-list" aria-hidden="true" />
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                                <td style={{ minWidth: 150 }}>
                                                    <div className="input-group">
                                                        <input
                                                            className="form-control"
                                                            disabled
                                                            readOnly
                                                            value={line?.OcrCode2 || ""} />

                                                        {((action === 1 || (action === 2 && editMode)) && !line?.Dimension2) && (
                                                            <div className="input-group-append" >
                                                                <button
                                                                    type="button"
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        color: '#EABF28',
                                                                        paddingTop: 2,
                                                                        paddingBottom: 2,
                                                                        border: "1px solid #ced4da"
                                                                    }}
                                                                    className="btn btn-outline-secondary"
                                                                    onClick={() => openCentroCoste(index, 2)}>
                                                                    <i className="fa fa-list" aria-hidden="true" />
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                                <td style={{ minWidth: 150 }}>
                                                    <div className="input-group">
                                                        <input
                                                            className="form-control"
                                                            disabled
                                                            readOnly
                                                            value={line?.OcrCode3 || ""} />

                                                        {((action === 1 || (action === 2 && editMode)) && !line?.Dimension3) && (
                                                            <div className="input-group-append" >
                                                                <button
                                                                    type="button"
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        color: '#EABF28',
                                                                        paddingTop: 2,
                                                                        paddingBottom: 2,
                                                                        border: "1px solid #ced4da"
                                                                    }}
                                                                    className="btn btn-outline-secondary"
                                                                    onClick={() => openCentroCoste(index, 3)}>
                                                                    <i className="fa fa-list" aria-hidden="true" />
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                                <td style={{ minWidth: 150 }}>
                                                    <div className="input-group">
                                                        <input
                                                            className="form-control"
                                                            disabled
                                                            readOnly
                                                            value={line?.OcrCode4 || ""} />

                                                        {((action === 1 || (action === 2 && editMode)) && !line?.Dimension4) && (
                                                            <div className="input-group-append" >
                                                                <button
                                                                    type="button"
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        color: '#EABF28',
                                                                        paddingTop: 2,
                                                                        paddingBottom: 2,
                                                                        border: "1px solid #ced4da"
                                                                    }}
                                                                    className="btn btn-outline-secondary"
                                                                    onClick={() => openCentroCoste(index, 4)}>
                                                                    <i className="fa fa-list" aria-hidden="true" />
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                                <td style={{ minWidth: 150 }}>
                                                    <div className="input-group">
                                                        <input
                                                            className="form-control"
                                                            disabled
                                                            readOnly
                                                            value={line?.OcrCode5 || ""} />

                                                        {((action === 1 || (action === 2 && editMode)) && !line?.Dimension5) && (
                                                            <div className="input-group-append" >
                                                                <button
                                                                    type="button"
                                                                    style={{
                                                                        backgroundColor: 'transparent',
                                                                        color: '#EABF28',
                                                                        paddingTop: 2,
                                                                        paddingBottom: 2,
                                                                        border: "1px solid #ced4da"
                                                                    }}
                                                                    className="btn btn-outline-secondary"
                                                                    onClick={() => openCentroCoste(index, 5)}>
                                                                    <i className="fa fa-list" aria-hidden="true" />
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </td>
                                            </>}

                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }

    renderFooter = () => {
        const { action, newOrderModel, editMode } = this.props;
        return (
            <div className="row">
                <div className="col-12 col-md-6">
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">Comentarios</span>
                        </div>
                        <textarea
                            type="text"
                            className="form-control styleTextarea"
                            id="txtCommentsGI"
                            autoComplete='off'
                            placeholder="250 caracteres máximo"
                            maxLength={254}
                            value={newOrderModel ? newOrderModel.Comments : ''}
                            onChange={(event) => this.ChangePropInModel("Comments", event.target.value)}
                            disabled={(action === 2 && !editMode) ? true : false}
                        />
                    </div>
                    <div className="input-group mb-3">
                        <div className="input-group-prepend">
                            <span className="input-group-text font-weight-bold" id="basic-addon1">
                                <span className="d-none d-xl-inline">Entrada en el diario</span>
                                <span className="d-inline d-xl-none">Entrada diario</span>
                            </span>
                        </div>
                        <input
                            type="text"
                            className="form-control"
                            id="txtJmlMemoGI"
                            value={newOrderModel ? newOrderModel.JournalMemo : ''}
                            disabled={true}
                        />
                    </div>
                </div>
                <div className="col-sm" style={{ paddingRight: 0 }}>
                </div>
            </div>
        );
    }

    render() {
        const { render } = this.props;
        let content = '';
        switch (render) {
            case 'header':
                content = this.renderHeader();
                break;
            case 'body':
                content = this.renderBody();
                break;
            case 'footer':
                content = this.renderFooter();
                break;
            default:
                content = '';
        }

        return (
            <div className='Content'>
                {content}
            </div>
        );
    }
}

export default ContentGoodsIssue;